import { html } from 'lit';
import { repeat } from 'lit/directives/repeat.js';

export const renderImages = (images: string[]) => {
  const validIsVideo = (base64: string): boolean | null => {
    if (typeof base64 !== "string") return null;
    const data = base64.trim();

    const match = data.match(/^data:([^;]+);base64,/);
    const mime = match ? match[1].toLowerCase() : null;
    const pureBase64 = data.replace(/^data:[^;]+;base64,/, "");
    const startsWith = (prefix: string) => pureBase64.startsWith(prefix);

    if (mime) {
      switch (mime) {
        case "image/jpeg":
        case "image/png":
          return false; // 图片
        case "video/mp4":
        case "video/quicktime":
          return true;  // 视频
        case "application/octet-stream":
          // 继续往下用文件头判断
          break;
        default:
          return null;
      }
    }

    // JPG: /9j/
    if (startsWith("/9j/")) return false;

    // PNG: iVBOR
    if (startsWith("iVBOR")) return false;

    // MP4: AAAAFGZ0eXBtcDQy (或类似)
    if (startsWith("AAAAFGZ0eXBtcDQy") || startsWith("AAAAGGZ0eXBtcDQy")) return true;

    // MOV: AAAAFGZ0eXBxd (或类似)
    if (startsWith("AAAAFGZ0eXBxd") || startsWith("AAAAGGZ0eXBxd")) return true;

    // ---------------------------
    // 🚫 无法识别
    // ---------------------------
    return null;
  };

  function fixMimeForMov(base64) {
    if (base64.startsWith("data:application/octet-stream;base64,")) {
      const byteChars = atob(base64.replace('data:application/octet-stream;base64,', ''));
      const byteNumbers = new Array(byteChars.length);
      for (let i = 0; i < byteChars.length; i++) {
        byteNumbers[i] = byteChars.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "video/quicktime" });
      return URL.createObjectURL(blob);
    }
    return base64;
  }



  return html`<style>
      .images-container {
        display: flex;
        gap: 12px;
        flex-direction: column;
        margin-bottom: 8px;
      }
      .image-container {
        border-radius: 4px;
        overflow: hidden;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 70%;
        max-width: 320px;

        img {
          max-width: 100%;
          max-height: 100%;
          width: auto;
          height: auto;
        }
      }
    </style>
    <div class="images-container">
      ${repeat(
        images,
        image => image,
        (image, index) => {
          const isVideo = validIsVideo(image)
          if (isVideo) return html`<div class="video-container">
            <video
                style="width: 100%;height: 100%;"
              title="视频${index}"
              src="${fixMimeForMov(image)}"
              controls
            />
          </div>`;
          return html`<div class="image-container">
            <img src="${image}" />
          </div>`;
        }
      )}
    </div>`;
};
